import signedFetch from '../util/signedFetch';
import { CONTENT_PACKAGE_TYPES } from '../../../../globals/cptConstants';

export default function* getContentSignedUrl(fileName, packageId, packageType) {
  const URL =
    packageType === CONTENT_PACKAGE_TYPES.EPUB
      ? `${__API_BASE__}/content/upload/generate-signed-url-for-epubs?fileName=${fileName}`
      : `${__API_BASE__}/content/upload/generate-signed-url?fileName=${fileName}&packageId=${packageId}&packageType=${packageType}`;
  return yield signedFetch('generateContentSignedUrl', URL, 'POST', null, null, false, true);
}
